import { v4 as uuid } from 'uuid';

const LoaderBussines = () => {
  const generateCards = () => {
    const list = Array(19).fill('.');
    return list.map(() => {
      return (
        <div id="cardBussines" key={uuid()}>
          <div className="boxCard">
            <div className="idContainer">
              <div className="w-48 h-24 rounded-md animationLoader" />
            </div>
            <div className="dateContainer">
              <div className="w-48 h-24 rounded-md animationLoader" />
            </div>
            <div className="rfcContainer">
              <div className="w-48 h-24 rounded-md animationLoader" />
            </div>
            <div className="nameContainer">
              <div className="w-64 h-24 rounded-md animationLoader" />
            </div>
            <div className="statusContainer">
              <div className="approved animationLoader" />
            </div>
            <div className="creditContainer">
              <div className="w-48 h-24 animationLoader" />
            </div>
          </div>
        </div>
      );
    });
  };
  return <div className="w-full">{generateCards()}</div>;
};

export default LoaderBussines;
